import { ShipTo } from "models/ShipTo";
import { FC } from "react";
import { Col, Row } from "react-bootstrap";
import { DefaultCompProps } from "./type";

const ShiptoDetail: FC<DefaultCompProps & { shipTo: ShipTo } & Record<string, any>> = (props) => {
    const { style, className, shipTo, ...otherProps } = props;

    return <>
        <div style={style} className={className}>
            {shipTo ? <>
                <Row>
                    <Col><strong>{shipTo.companyName}</strong></Col>
                </Row>
                <Row>
                    <Col>{shipTo.address}</Col>
                </Row>
                <Row>
                    <Col>{`${shipTo.city},${shipTo.postalCode}`}</Col>
                </Row>
            </> : <>No ShipTo Selected</>}
        </div>
    </>;
};
export default ShiptoDetail;